import { Component, Input, OnInit } from '@angular/core';
import { LocalizationService } from '../../services/localization.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthService } from '../../services/auth.service';
import { WSImport } from '../import.models';
import { ImporterService } from '../importer.service';
import { AvailabilityData } from '../../services/data.service';

@Component({
    selector: 'app-pg-import-preview-modal',
    templateUrl: './pg-import-preview-modal.component.html',
    styleUrls: ['./pg-import-preview-modal.component.scss'],
    standalone: false
})
export class PgImportPreviewModalComponent implements OnInit {

    constructor(private localizationService:LocalizationService, private importerService:ImporterService, private authService:AuthService, private activeModal:NgbActiveModal) {
    }
    
    @Input() importType:WSImport.JobType;
    @Input() resourceName:string;
    @Input() elementId:string;
    @Input() APIUrl:string;
    @Input() municipality:string;
    @Input() page:number;
    

    isLoading = false;
    isImporting = false;

    private _elementLayout:Array<{ field:string|Array<string>, large?: boolean }> = [
        { field: ['name','title'] },
        { field: 'availability' },
        { field: 'cover' },
        { field: 'short_description' },
        { field: ['description','text'] },
        { field: 'phone' },
        { field: 'email' },
        { field: 'website' },
        { field: 'geolocation' }, 
    ]

    private _elementTypes:{ [field:string]: string } = {
        cover: 'image',
        geolocation: 'location',
        short_description: 'html',
        description: 'html',
        text: 'html',
        availability: 'timetable-dates'
    }

    elementData:Array<{ 
        label: string, 
        value: any,
        type?: string,
        large?: boolean
    }> = null;

    lastModified:Date = null;
    lastImported:Date = null;


    ngOnInit() {
        this.elementData = []
        this.lastModified = null;
        this.lastImported = null;

        this.isLoading = true;

        this._getPreview().subscribe((data) => {
            this.isLoading = false;

            if(data.modified) this.lastModified = new Date(data.modified)
            if(data.imported) this.lastImported = new Date(data.imported)

            this.elementData = [];

            let _element = data.element;

            for(let _layout of this._elementLayout) {
                let _name = null;
                let _value = null;

                if(typeof _layout.field == 'string') {
                    _name = _layout.field;
                    _value = _element[_name]
                }
                else {
                    for(let _item of _layout.field) {
                        if(_element[_item] != null) {
                            _name = _item;
                            _value = _element[_item]
                        }
                    }
                }

                if(_value != null) {
                    let _label = this.localizationService.translate('RESOURCES.' + this.resourceName.replace(/~.*$/, '') + '.fields.' + _name + '.label')
    
                    this.elementData.push({
                        label: _label,
                        value: _value,
                        type: this._elementTypes[_name],
                        large: _layout.large
                    })
                }
            }
        })
    }

    private _getPreview() {
        if(this.importType == 'entourance') return this.importerService.getPreviewEntoruance(this.APIUrl, this.resourceName, this.elementId)
        else if(this.importType == 'wordpress') return this.importerService.getPreviewWordPress(this.APIUrl, this.resourceName, this.elementId)
        else if(this.importType == 'dhm') return this.importerService.getPreviewDHM(this.resourceName, this.elementId)
        else if(this.importType == 'eppoi') return this.importerService.getPreviewEPPOI(this.resourceName, this.elementId, this.municipality, this.page)
    }

    isModifiedSinceImport() {
        if(this.lastImported != null && this.lastModified != null) {
            return this.lastImported.getTime() < this.lastModified.getTime() 
        }
    }

    previewImport() {
        this.isImporting = true;

        if(this.importType == 'entourance') {
            this.importerService.importEntourance(this.APIUrl, [{ resource: this.resourceName, id: this.elementId }], this.authService.user.realm?.id).subscribe(() => {
                this.isImporting = false;
                this.activeModal.close()
            }, () => {
                this.isImporting = false;
            })
        }
        else if(this.importType == 'wordpress') {
            this.importerService.importWordPress(this.APIUrl, [{ resource: this.resourceName, id: this.elementId }], this.authService.user.realm?.id).subscribe(() => {
                this.isImporting = false;
                this.activeModal.close()
            }, () => {
                this.isImporting = false;
            })
        }
        else if(this.importType == 'dhm') {
            this.importerService.importDHM([{ resource: this.resourceName, id: this.elementId }], this.authService.user.realm?.id).subscribe(() => {
                this.isImporting = false;
                this.activeModal.close()
            }, () => {
                this.isImporting = false;
            })
        }
        else if(this.importType == 'eppoi') {
            let _item:WSImport.JobEPPOIItem = { resource: this.resourceName, id: this.elementId }
            if(this.municipality != null) _item.municipality = this.municipality
            if(this.page != null) _item.page = this.page

            this.importerService.importEPPOI([_item], this.authService.user.realm?.id).subscribe(() => {
                this.isImporting = false;
                this.activeModal.close()
            }, () => {
                this.isImporting = false;
            })
        }
    }

    dismissModal() {
        this.activeModal.dismiss()
    }

    formatAvailability(value:AvailabilityData) {
        return this.localizationService.format.timetable('dates', value)
    }
}
